var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7468 11.8587C29.4743 11.859 30.8746 13.2591 30.8747 14.9866V25.012C30.8746 26.7396 29.4743 28.1406 27.7468 28.1409H12.2526C10.5249 28.1408 9.12477 26.7397 9.12469 25.012V14.9866C9.12478 13.2589 10.5249 11.8588 12.2526 11.8587H27.7468ZM10.8239 19.0257V25.012C10.824 25.8008 11.4638 26.4406 12.2526 26.4407H27.7468C28.5354 26.4404 29.1744 25.8007 29.1745 25.012V19.0257H10.8239ZM12.2526 13.5579C11.4638 13.558 10.824 14.1978 10.8239 14.9866V17.3265H29.1745V14.9866C29.1744 14.198 28.5354 13.5582 27.7468 13.5579H12.2526Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIcon);
export default __webpack_public_path__ + "static/media/payIcon.26dfe6be1463c33a9b315e55ed166aea.svg";
export { ForwardRef as ReactComponent };